import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { Refund } from '../../models/refund.model'
import { SharedService } from 'src/app/shared/services/shared.service'
import { RefundService } from '../../services/refund.service'
import { environment } from 'src/environments/environment'
import { RefundDetailsStatus } from '../../models/refund-details.enum'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { ToastrService } from 'ngx-toastr'
import { MatDialog } from '@angular/material/dialog'

@Component({
	selector: 'app-refund-details',
	templateUrl: './refund-details.component.html',
	styleUrls: ['./refund-details.component.scss'],
})
export class RefundDetailsComponent implements OnInit {
	subscription = new Subscription()
	formData: FormGroup = new FormGroup({})

	refundData!: Refund
	imagePath = environment.attachmentPath
	refundStatus = RefundDetailsStatus
	breadCrumbRout: any
	matValue: any

	constructor(
		private activeRout: ActivatedRoute,
		public translate: TranslateService,
		private SharedService: SharedService,
		private refundService: RefundService,
		private toaster: ToastrService,
		private dialog: MatDialog,
		private router: Router
	) {
		this.initForm()

		let rout = this.SharedService.breadCrumbRout.subscribe((res: any) => {
			this.breadCrumbRout = res
		})
		rout.unsubscribe()
		this.breadCrumbRout['refund-details'] = {
			name: '',
			id: '',
			url: '',
			queryParams: null,
		}
		this.SharedService.breadCrumbRout.next(this.breadCrumbRout)
	}

	ngOnInit(): void {
		this.initForm()
		const id = this.activeRout.snapshot.params['id']
		this.getRefund(id)
		this.subscription.add(
			this.formData.valueChanges.subscribe((res) => {
				this.matValue = this.getController('payStatus').value
			})
		)
	}
	ngOnChanges(): void {
		this.initForm()
	}
	initForm() {
		this.formData = new FormGroup({
			payStatus: new FormControl('', [Validators.required]),
			refundAmount: new FormControl(this.refundData?.bookingAmount, [
				Validators.required,
				Validators.min(1),
				Validators.max(this.refundData?.bookingAmount),
			]),
			refundActionNotes: new FormControl('', [Validators.required]),
		})
		this.subscription.add(
			this.formData.valueChanges.subscribe((res) => {
				this.matValue = this.getController('payStatus').value
			})
		)
	}
	getRefund(id: number) {
		this.subscription.add(
			this.refundService.getRefund(id).subscribe((res: any) => {
				this.refundData = res.result
			})
		)
	}

	acceptRefund() {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '485px',
				data: {
					notflex: true,
					image: 'assets/images/empty-wallet-change.svg',
					message: 'CONFIRMATION_MESSAGE.ARE_YOU_SURE_TO_COMPLETE_REFUND',
					cancelBtn: 'ACTIONS.NO',
					confirmBtn: 'ACTIONS.YES',
					title: 'ACTIONS.PROCEED_REFUND',
					confirmBtnStyle: `bg-gradient text-white`,
					cancelBtnStyle: ` border-[1px] border-secondry-color-Gray text-dark-grey border-solid`,
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						delete this.formData.controls['payStatus']

						let body = {
							id: this.refundData.id,
							refundDate: new Date(),
							...this.formData.getRawValue(),
						}

						this.subscription.add(
							this.refundService.acceptRefundRequest(body).subscribe((res) => {
								this.toaster.success(
									this.translate.instant('TOASTER.REFUND_SUCCESS')
								)
								this.router.navigate(['/layout/refunds/'])
							})
						)
					}
				},
			})
	}
	rejectRefund() {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '485px',
				data: {
					notflex: true,
					image: 'assets/images/wallet-remove.svg',
					message: 'CONFIRMATION_MESSAGE.ARE_YOU_SURE_TO_REJECT_REFUND',
					cancelBtn: 'ACTIONS.NO',
					confirmBtn: 'ACTIONS.YES',
					title: 'ACTIONS.REJECT_REFUND',
					hasInput: true,
					label: 'REFUND.REFUND_DETAILS.REASON',
					confirmBtnStyle: `text-off-white bg-red-error`,
					cancelBtnStyle: ` border-[1px] border-secondry-color-Gray text-dark-grey border-solid`,
				},
				autoFocus: false,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						let body = {
							id: this.refundData.id,
							refundDate: new Date(),
							refundAmount: 0,
							refundActionNotes: res.msg,
						}

						delete this.formData.controls['payStatus']

						this.subscription.add(
							this.refundService.rejectRefundRequest(body).subscribe((res) => {
								this.toaster.success(
									this.translate.instant('TOASTER.REFUND_REJECT')
								)
								this.router.navigate(['/layout/refunds/'])
							})
						)
					}
				},
			})
	}

	getController(controlName: string) {
		return this.formData.controls[controlName]
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
